export default {"src":"/_next/static/media/schieten.0e64df83.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};